import React from 'react';

const FeatureCard = ({
    title,
    label,
    sublabel,
    icon: Icon,
    points,
    tags,
    ProcessSVG,
    color = "from-blue-600 to-blue-400",
    borderColor = "border-blue-500",
    shadowColor = "shadow-blue-500/20",
    active = false,
    onMouseEnter
}) => {
    return (
        <div
            className={`group relative bg-gradient-to-b from-slate-800/80 to-slate-900/80 rounded-xl border transition-all duration-300 
                ${active ? borderColor + ' ' + shadowColor : 'border-slate-700/50'} 
                hover:${borderColor} hover:${shadowColor} cursor-pointer`}
            onMouseEnter={onMouseEnter}
        >
            {/* Simple hover effect */}
            <div className={`absolute inset-0 bg-gradient-to-br ${color} opacity-0 group-hover:opacity-5 transition-opacity duration-500`}></div>

            {/* Main Content */}
            <div className="relative z-10 p-8">
                <div className="flex gap-6">
                    {/* Left Content */}
                    <div className="flex-1 relative z-10 max-w-[60%]">
                        <div className="flex items-center gap-6 mb-8">
                            {/* Icon with animated background */}
                            <div className={`relative w-20 h-20 rounded-full border-4 ${active ? borderColor : 'border-slate-700'}`}>
                                <div className={`absolute inset-0 rounded-full bg-gradient-to-r ${color} opacity-10 ${active ? 'animate-pulse' : ''}`} style={{ animationDuration: '3s' }}></div>
                                <div className="absolute inset-0 flex items-center justify-center">
                                    {Icon && <Icon className={`w-12 h-12 ${active ? 'text-' + color.split('-')[2] : 'text-slate-400'}`} />}
                                </div>
                            </div>

                            <div>
                                <h3 className="text-3xl font-bold text-white tracking-wide mb-2">{title}</h3>
                                <p className="text-lg text-white brightness-150 leading-relaxed">{label}</p>
                            </div>
                        </div>

                        <div className="space-y-6">
                            <p className="text-lg text-slate-300 leading-relaxed">{sublabel}</p>

                            {/* Points */}
                            {points && points.length > 0 && (
                                <ul className="space-y-3">
                                    {points.map((point, idx) => (
                                        <li key={idx} className="flex items-center">
                                            <div className={`flex-shrink-0 bg-gradient-to-r ${color} opacity-20 p-1.5 rounded-full mr-3`}>
                                                <div className="w-4 h-4 text-white">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                        <polyline points="9 18 15 12 9 6"></polyline>
                                                    </svg>
                                                </div>
                                            </div>
                                            <span className="text-sm text-slate-300">{point}</span>
                                        </li>
                                    ))}
                                </ul>
                            )}

                            {/* Tags */}
                            {tags && tags.length > 0 && (
                                <div className="flex flex-wrap gap-3 pt-4">
                                    {tags.map((tag, idx) => (
                                        <div
                                            key={idx}
                                            className={`flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r ${color} bg-opacity-10 text-white text-sm hover:bg-opacity-20 transition-all duration-300`}
                                        >
                                            <span>{tag}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Right SVG */}
                    {ProcessSVG && (
                        <div className="w-[40%] flex items-center justify-center">
                            <div className="flex items-center justify-center w-full h-full">
                                <div className="transform-gpu opacity-90 w-full h-full flex items-center justify-center">
                                    <ProcessSVG className="w-full h-full max-w-[200px] max-h-[200px] object-contain" />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FeatureCard;